/* unplugin-vue-components disabled */import { render } from "./PromocodeCampaigns.vue?vue&type=template&id=576e75da&scoped=true&ts=true"
import script from "./PromocodeCampaigns.vue?vue&type=script&lang=ts"
export * from "./PromocodeCampaigns.vue?vue&type=script&lang=ts"

import "./PromocodeCampaigns.vue?vue&type=style&index=0&id=576e75da&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576e75da"]])

export default __exports__